import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { UserModule } from '../../modules/UserModule';

const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={(props) => {
            if (UserModule.isLoggedIn()) {
                return <Component {...rest} {...props} />;
            } else {
                return <Redirect to='/login' />;
            }
        }}
        />
    );
};

export default PrivateRoute;